<template>
<div class="index">
  <div class="gd">
    <div class="gd_d1">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/' }"
          >全部商品分类</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ detail.Name }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="gd_d2">
      <div class="gdd2_left">
        <div class="gdd2left_d1">
          <div class="gdd2leftd1_d1">
            <pic-zoom
              v-if="device !== 'mobile'"
              :url="addImgUrl(imgList[selectIndex])"
              :scale="3"
            ></pic-zoom>

            <img
              v-else
              class="gdd2leftd1_d1_mobile"
              :src="addImgUrl(imgList[selectIndex])"
            />
          </div>
        </div>
        <div class="gdd2left_d2">
          <div class="gdd2left_d2_left" @click="toLeft">
            <i class="el-icon-caret-left"></i>
          </div>
          <div class="gdd2left_d2_m">
            <div
              :style="'left:' + leftNum + 'px'"
              @mouseover="mouseOver(index)"
              :class="
                'gdd2left_d2_m_d' +
                (selectIndex == index ? ' gdd2left_d2_m_select' : '')
              "
              v-for="(item, index) in imgList"
              :key="index"
            >
              <img :src="addImgUrl(item)" />
            </div>
          </div>
          <div class="gdd2left_d2_left gdd2left_d2_right" @click="toRight">
            <i class="el-icon-caret-right"></i>
          </div>
        </div>
      </div>
      <div class="gdd2_right">
        <div class="gdd2r_sp1">{{ detail.Title }}</div>
        <div class="gdd2r_d2 gdd2r_d3">{{ title }}</div>
        <div class="gdd2r_d4">
          价格：
          <span
            >￥<span class="pic">{{ detail.Price }}</span></span
          >
        </div>
        <div class="gdd2r_d2 gdd2r_d4">
          配送：吉林长春&nbsp;至&nbsp;<a @click="showselect=true">{{selectedCity=='' ?'金华市 婺城区':selectedCity +selectedDistrict}}</a>
          <div class="gdd2rkd">快递：免运费16:00前付款，今天发货</div>
        </div>
        <div  class="xuanz" v-if="showselect">
          <div>
            <select v-model="selectedProvince" @change="getCityData">
              <option value="">请选择省份</option>
              <option v-for="(item, index) in provinces" :value="item" :key="index">{{ item }}</option>
            </select>
            <select v-model="selectedCity" @change="getDistrictData">
              <option value="">请选择城市</option>
              <option v-for="(item, index) in cities" :value="item.Name" :key="index">{{ item.Name }}</option>
            </select>
            <select v-model="selectedDistrict" @change="showselect=false">
              <option value="">请选择地区</option>
              <option  v-for="(item, index) in districts" :value="item.Name" :key="index">{{ item.Name }}</option>
            </select>
          </div>
          
          <button class="close-button" @click="showselect=false">关闭</button>
        </div>
        <div class="gdd2r_d2 gdd2r_d5">
          数量：
          <el-input-number
            v-model="num"
            size="small"
            @change="handleChange"
            :min="1"
            :max="10"
            label="描述文字"
          ></el-input-number>
        </div>
        <div class="gdd2r_d2 gdd2r_d6">库存：{{ detail.KuCun }}</div>
        <div class="gdd2r_d7">
          <el-button type="danger" @click="AddCart">加入购物车</el-button>
          <el-button type="danger" plain @click="toBuy">立即购买</el-button>
        </div>
      </div>
    </div>
    <div class="gd_d3">
      <div
        class="pre_left"
        v-if="device !== 'mobile' && browseList && browseList.length !== 0"
      >
        <span class="prel_sp1">热卖推荐</span>
        <div
          class="prel_d2"
          v-for="(item, index) in browseList"
          :key="index"
          @click="toDetail(item.id)"
        >
          <img :src="addImgUrl(item.Pic)" />
          <span>{{ item.Title }}</span>
          <span>￥{{ item.Price }}</span>
        </div>
      </div>
      <div class="gdd3_right">
        <el-tabs
          v-model="activeName"
          type="border-card"
        >
          <el-tab-pane label="商品详情" name="1">
            <div v-html="content"></div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div style="height: 50px"></div>
  </div>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import { addImgUrl } from "@/utils";
import { toLogin } from "@/utils";
import PicZoom from "vue-piczoom";
export default {
  data() {
    return {
      num: 1,
      activeName: "1",
      leftNum: 0,
      selectIndex: 0,
      detail: "",
      title:'',
      content:'',
      id: "",
      ProductSizeId:'',
      browseList: [],
      imgList: [],
      imgsLength: 10,
      imgUrl: "",
      provinces: [],
      cities: [],
      districts: [],
      selectedProvince: "",
      selectedCity: "",
      selectedDistrict: "",
      showselect:false,
    };
  },
  components: {
    PicZoom,
  },
  computed: {
    ...mapGetters(["device" ,"userId"]),
  },
  watch: {},
  created: function () {
    if (typeof this.$route.query.id != "undefined") {
      this.id = this.$route.query.id;
      this.productDeatil();
    }
    this.GetindexProduct();
  },
  mounted: function () {
    this.getProvinces();
  },
  beforeRouteUpdate(to, from, next) {
    this.id = to.query.id; // 监听参数变化并更新数据
    this.productDeatil(); // 重新获取数据
    next();
  },
  methods: {
    addImgUrl,
    async getProvinces() {
        let res = await this.$post("DefaultProvList", {});
        // console.log(res,'DefaultProvList');
        this.provinces = res.data.ResultData.ProvinceList;
    },
    async getCityData() {
        let res = await this.$post("GetCityTownList", {province:this.selectedProvince});
        // console.log(res,'GetCityTownList');
        this.cities = res.data.ResultData.CityList;
        this.selectedCity = '';
        this.districts = [];
        this.selectedDistrict = '';
    },
    async getDistrictData() {
        let res = await this.$post("GetTownList", {city:this.selectedCity});
        console.log(res,'GetTownList');
        this.districts = res.data.ResultData;
        this.selectedDistrict = '';
        if(res.data.ResultData.length==0 ){
            this.showselect=false
        }
    },
    mouseOver(index) {
      this.selectIndex = index;
    },
    toDetail(id) {
				this.$router.replace({
					path: '/ncpgoodsdetail',
					query: {
						id: id,
					}
				});
			},
    async productDeatil() {
      let res = await this.$post("productDeatil", {
        id: this.id,
      });
      console.log(res,'productDeatil');
      this.detail = res.data.ResultData;
      let content = res.data.ResultData.Cont;
      this.title = res.data.ResultData.SizeList[0].Title;
      this.ProductSizeId=res.data.ResultData.SizeList[0].id;
      this.content = content.replace(/\<img/gi, '<img style="max-width:100%;height:auto;"');
       console.log(this.content,'content');
      this.imgList = res.data.ResultData.Pic.split(",");
    },
    async GetindexProduct() {
      let res = await this.$post("GetindexProduct", {});
      this.browseList = res.data.ResultData;
      console.log(res,'GetindexProduct');
      for (var i in this.browseList) {
        this.browseList[i].Pic = this.browseList[i].Pic.split(",")[0];
      }
    },
    async toBuy() {
      if (this.userId == "") {
        toLogin(this)
        this.$message.error("请先登录后查看");
      }
      if(this.ProductSizeId==''){
        this.$message.error("商品维护中，暂不可购买");
      }else{
        var res = await this.$post('AtonceSaveOrder', {
            proId: this.id,
            Count: this.num,
            proSizeId: this.ProductSizeId,
        })
      }
        
        if(res.data.ResultData.OrderNo){
          this.$router.push({
            path: "/buy",
            query: {
              OrderNo: res.data.ResultData.OrderNo,
              },
          });
        }else{
          this.$message.error("下单失败");
        }
        
    },
    async AddCart() {
      if (this.userId == "") {
        this.$router.push("/login");
        this.$message.error("请先登录后查看");
        return;
      }
      if(this.ProductSizeId==''){
        this.$message.error("商品维护中，暂不可加入购物车");
      }else{
        let res = await this.$post("AddCart", {
          ProductId: this.id,
          Count: this.num,
          ProductSizeId:this.ProductSizeId
        });
        console.log(res,'addcart');
        this.$store.commit('updatecarSize', res.data.RowCount)
        if (res.data.Success == "true") {
          this.$message({
            message: res.data.Msg,
            type: "success",
          });
        } else {
          this.$message.error(res.data.Msg);
        }
      }
    },
    toLeft() {
      if (this.imgList.length < 4) {
        return;
      }
      if (this.leftNum / 83.8 >= 0) {
        return;
      }
      if (-(this.leftNum / 83.8 + 4) < 0) {
        var num = parseInt(this.leftNum / 83.8 + 4);
        this.leftNum += 83.8 * num;
        return;
      }
      this.leftNum += 83.8 * 4;
    },
    toRight() {
      if (this.imgList.length < 4) {
        return;
      }
      if (-(this.leftNum / 83.8 - 8) > this.imgsLength) {
        var num = this.leftNum / 83.8 - 4 + this.imgsLength;
        this.leftNum -= 83.8 * num;
        return;
      }
      if (this.leftNum / 83.8 - 4 <= -this.imgsLength) {
        return;
      }
      this.leftNum -= 83.8 * 4;
    },
    handleChange(value) {
      console.log(value);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped >
.index {
  width: 100%;
  background-image: url("../Home/img/组17.png");
  background-size: cover;
  /* 调整背景图片的尺寸，以填充整个容器 */
  background-position: center;
}
.gd {
  width: 1200px;
  margin: 0px auto;
  background-color: #fff;
}

.gd_d1 {
  width: 100%;
  padding: 25px 0 13px;
  box-sizing: border-box;
  border-bottom: 1px solid #dedede;
  margin-bottom: 15px;
}

.gd_d2 {
  width: 1200px;
  margin: 0px auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.gdd2_left {
  display: flex;
  flex-direction: column;
  width: 380px;
}

.gdd2left_d1 {
  width: 380px;
  height: 380px;
  box-sizing: border-box;
  border: 1px solid #dedede;
  display: flex;
  align-items: center;
  justify-content: center;
}

.gdd2leftd1_d1 {
  width: 370px;
  height: 370px;
  overflow: hidden;
}

.gdd2leftd1_d1 img {
  width: 370px;
  height: 370px;
}

.gdd2left_d2 {
  width: 380px;
  height: 75px;
  display: flex;
  flex-direction: row;
  margin-top: 10px;
}

.gdd2left_d2_left {
  width: 18px;
  height: 75px;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  background-color: #f8f8f8;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0.8;
}

.gdd2left_d2_m {
  width: 344px;
  height: 75px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

.gdd2left_d2_m div {
  margin-left: 8.8px;
  width: 75px;
  height: 75px;
  border-width: 2px;
  border-style: solid;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  transition: left 0.6s;
}
.xuanz{
  position: absolute;
  top: 105%; /* 设置在选择地址容器下方 */
  left: 39%;
  /* 其他样式属性 */
  background-color: #ffffff;
  padding: 10px;
  border: 1px solid #ccc;
  z-index: 999;
}
.close-button {
  background-color: #ccc;
  color: #fff;
  border: none;
  padding: 5px 10px;
  margin-top: 5px;
  float: right;
  border-radius: 20px;
}
.gdd2left_d2_m img {
  width: 71px;
  height: 71px;
}

.gdd2_right {
  width: 792px;
}

.gdd2r_sp1 {
  width: 792px;
  font-size: 24px;
  color: #333333;
  box-sizing: border-box;
  border-bottom: 1px dashed #dddddd;
  padding: 0 0 10px 15px;
}

.gdd2r_d2 {
  width: 100%;
  margin: 12px 0 22px;
  font-size: 14px;
  color: #333333;
  padding: 0 15px;
}

.gdd2r_d2 span:nth-child(1) {
  font-size: 24px;
  color: #e80000;
}

.gdd2r_d2 span:nth-child(2) {
  color: #999999;
  text-decoration: line-through;
  margin-left: 10px;
}
.gdd2rkd{
    width: 100%;
    margin: 12px 0 22px;
    font-size: 14px;
    color: #333333;
    /* padding: 0 45px; */
}
.gdd2r_d3 {
  margin-top: 0px;
  font-size: 20px;
}

.gdd2r_d4 {
  width: 100%;
  padding: 15px;
  font-size: 14px;
}

.gdd2r_d4 span {
  color: #ba2624;
  font-size: 18px;
}
.gdd2r_d4 .pic {
  font-size: 32px;
}

.gdd2r_d5 {
  margin-top: 18px;
}

.gdd2r_d6 {
  margin-top: 0px;
}

.gdd2r_d7 {
  width: 100%;
  box-sizing: border-box;
  border-top: 1px dashed #dddddd;
  display: flex;
  flex-direction: row;
  padding-top: 24px;
  padding-left: 15px;
}
.gdd2r_d7 button{
    width: 180px;
}
.gd_d3 {
  margin-top: 55px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.pre_left {
  margin-top: 0px;
}

.gdd3_right {
  width: 970px;
}
.prel_d2{
    border: 1px solid #dddddd;
}
</style>

<style lang="scss" scoped src="./mobile.scss" ></style>